export const useWhitelist = () => {
  const IS_WHITELIST_IGNORE = process.env.REACT_APP_IGNORE_WHITELIST;
  return {
    isIgnoreWhitelist: IS_WHITELIST_IGNORE === "true",
  };
};
